import type { EnderecosBloqueadosModel } from "../models/enderecosBloqueadosModel"
import {
    EnderecosBloqueadosActionsTypes,
    type EnderecosBloqueadosActions,
} from "./enderecosBloqueadosActions"

export function enderecosBloqueadosReducer(
    state: EnderecosBloqueadosModel,
    action: EnderecosBloqueadosActions
): EnderecosBloqueadosModel {
    switch (action.type) {
        case EnderecosBloqueadosActionsTypes.CARREGAR:
            return { ...state, lista: action.payload }
        default:
            return state
    }
}
